import React from 'react';
import PropTypes from 'prop-types';
import { Message, translator } from 'mage-i18n';
import { connect } from 'react-redux';

import TermsAndConditionsLink from '@/components/TermsAndConditionsLink';

const tKey = 'products-fe.components.store_details_summary.toc_data.toc_approval_text';

const MerchantProductTermsAndConditions = ({ t, tocData, country }) =>
  tocData.map(tocDataElement => {
    const tKeyProduct = `moet-core.products.${
      tocDataElement.mainProductId ? `${tocDataElement.mainProductId}.options.` : ''
    }${tocDataElement.id}.name`;
    const links = (tocDataElement.tocSource || tocDataElement.tocLink || '').split(',');

    if (!links || links.length === 0) {
      return null;
    }

    const [merchantAgreementLink, pricingAnnexLink] = links;

    return (
      <>
        {merchantAgreementLink && (
          <TermsAndConditionsLink
            key={`${tocDataElement.mainProductId}-${tocDataElement.id}-merchant-agreement`}
            tocLink={merchantAgreementLink}
            textBeforeLink={
              <Message path={`${tKeyProduct}.${country}`} fallback={t(`${tKeyProduct}.default`)} />
            }
            linkText={
              <Message
                path={`${tKey}${pricingAnnexLink ? `.merchant_agreement` : ''}.link_text`}
                dangerous
              />
            }
            textAfterLink={
              <Message
                path={`${tKey}${pricingAnnexLink ? `.merchant_agreement` : ''}.after_link`}
                params={{ date: tocDataElement.tocTimestamp }}
              />
            }
            light
          />
        )}
        {pricingAnnexLink && (
          <TermsAndConditionsLink
            key={`${tocDataElement.mainProductId}-${tocDataElement.id}-pricing-annex`}
            tocLink={pricingAnnexLink}
            textBeforeLink={
              <Message path={`${tKeyProduct}.${country}`} fallback={t(`${tKeyProduct}.default`)} />
            }
            linkText={<Message path={`${tKey}.pricing_annex.link_text`} dangerous />}
            textAfterLink={
              <Message
                path={`${tKey}.pricing_annex.after_link`}
                params={{ date: tocDataElement.tocTimestamp }}
              />
            }
            light
          />
        )}
      </>
    );
  });

MerchantProductTermsAndConditions.propTypes = {
  t: PropTypes.func.isRequired,
  tocData: PropTypes.array.isRequired,
  country: PropTypes.string,
};

export default connect(state => ({
  t: translator(state),
}))(MerchantProductTermsAndConditions);
